<template>
  <div class="container">
    <span class="title">{{ titleOne }}</span>
    <TableThree

      :valor="valor"
      :ceseRetiro="ceseRetiro"
    />
    <span class="title">{{ titleTwo }}</span>
    <TableFour :ceseRetiro="ceseRetiro" :readOnly="readOnly" />
    <span class="title">{{ titleThree }}</span>
    <TableFive
      :porcentajeRecuperacion="porcentajeRecuperacion"
      :ceseRetiro="ceseRetiro"
      :readOnly="readOnly"
    />
  </div>
</template>

<script>
import TableThree from "./components/TableThree";
import TableFour from "./components/TableFour.vue";
import TableFive from "./components/TableFive.vue";
import store from "../../../../store";
export default {
  props: [ "ceseRetiro", "porcentajeRecuperacion", "valor", "readOnly"],
  components: {
    TableThree,
    TableFour,
    TableFive,
  },
  data() {
    return {
      titleOne:
        "2.1 Porcentaje de egresos del Servicio respecto de la dotación efectiva",
      titleTwo: "2.2 Causales de cese o retiro",

      // Tercera Tabla
      titleThree: "2.3 Porcentaje de recuperación de funcionarios",
      encabezado: "variables",
      textOne:
        "(a) N° de funcionarios que ingresan a la dotación del Servicio año t",
      textTwo:
        "(b) N° de funcionarios que cesan o se retiran del Servicio por cualquier causal año t",
      textThree: "Porcentaje de recuperación (a/b)",
      inputFour: "",
      inputOne: "",
      inputTwo: "",
      inputThree: "",
      inputFive: "",
      inputSix: "",
      porcentajeOne: "",
      porcentajeTwo: "",
      porcentajeThree: "",
      porcentaje: "100",
      intPorcentajeOne: null,
      intPorcentajeTwo: null,
      intPorcentajeThree: null,
      tableOne: null,
    };
  },

  mounted() {
    setTimeout(() => {
      this.tableOne = this.tableStore;
      console.log("mainTabletwo", this.tableOne);
    }, 3000);
  },

  updated() {
    this.porcentajeOne =
      (parseInt(this.inputOne) / parseInt(this.inputFour)) *
      parseInt(this.porcentaje);
    this.intPorcentajeOne = this.porcentajeOne.toFixed(2);
    console.log("hola", this.inputOne);

    //Segundo Porcentaje
    this.porcentajeTwo =
      (parseInt(this.inputTwo) / parseInt(this.inputFive)) *
      parseInt(this.porcentaje);
    this.intPorcentajeTwo = this.porcentajeTwo.toFixed(2);

    //Tercer Porcentaje
    this.porcentajeThree =
      (parseInt(this.inputThree) / parseInt(this.inputSix)) *
      parseInt(this.porcentaje);
    this.intPorcentajeThree = this.porcentajeThree.toFixed(2);

    store.dispatch("rHumanos/actionsTable", {
      value: [
        {
          dataA: this.inputOne,
          dataB: this.inputFour,
          porcentajeIngresos: this.porcentajeOne,
        },
        {
          dataA: this.inputTwo,
          dataB: this.inputFive,
          porcentajeIngresos: this.porcentajeTwo,
        },
        {
          dataA: this.inputThree,
          dataB: this.inputSix,
          porcentajeIngresos: this.porcentajeThree,
        },
      ],
      nameTable: "porcentajeRecuperacion",
    });
  },
};
</script>

<style scoped>
.title {
  color: #052333;
  font-size: 17px;
  font-weight: bold;
  margin-top: 10px !important;
  margin-bottom: 10px;
}
</style>
